// @todo: Translations

const SOLR_SEARCH_REST_CONFIG_VENUES = {
  endpoint: `/api/search/venues`,
  pageMode: "endless", // endless or pager or none
  search: true,
  fields: [],
  facets: [
    {
      id: "venues_branch",
      label: "Type",
      type: "select",
      multiple: false,
      isFrontendId: true,
    },
    {
      id: "venues_accessibility",
      label: "Accessibility",
      type: "select",
      multiple: false,
    }
  ],
  presetFilters: [],
  pagerSize: 9,
};

export default SOLR_SEARCH_REST_CONFIG_VENUES;
